(function () {
  'use strict';

  function init(root) {
    if (root.dataset.btsTrustReady === 'true') return;
    root.dataset.btsTrustReady = 'true';

    var track = root.querySelector('[data-bts-trust-track]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-bts-trust-dot]'));
    if (!track || dots.length < 2) return;

    var slides = Array.prototype.slice.call(track.children);

    function setActive(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function currentIndex() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) return 0;
      if (track.scrollLeft >= maxScroll - 2) return slides.length - 1;
      var step = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth;
      return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / step)));
    }

    var ticking = false;
    track.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          setActive(currentIndex());
          ticking = false;
        });
      },
      { passive: true }
    );

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var slide = slides[i];
        if (!slide) return;
        track.scrollTo({ left: slide.offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-bts-trust]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var el = event.target.querySelector('[data-bts-trust]');
    if (el) init(el);
  });
})();
